export default class extends Controller {
  static targets = ['input', 'select'];

  connect() {
    this.postDraft();
    this.addHandlersToSelects();
    [...this.element.querySelectorAll('trix-editor')].forEach(t => t.addEventListener('trix-change', this.markDirty.bind(this)));
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  addHandlersToSelects() {
    this.selectTargets.forEach(select => App.DynamicSelect.onChange(select, this.markDirty.bind(this)));
  }

  addHandlersToNewElements() {
    setTimeout(this.addHandlersToSelects.bind(this), 100);
  }

  postDraft() {
    if (this.hasChanges) {
      this.hasChanges = false;
      App.Helpers.ajaxRequest({
        url:            this.url,
        method:         'POST',
        data:           [...this.inputTargets].reduce((data, input) => ({ ...data, [input.name]: $(input).val() }), {}),
        errorHandler:   () => this.hasChanges = true
      });
    }
    this.timeout = setTimeout(this.postDraft.bind(this), 5000);
  }

  markDirty() {
    this.hasChanges = true;
  }

  //
  // GETTERS AND SETTERS
  //

  get hasChanges() {
    return this.element.classList.contains('has-changes');
  }

  set hasChanges(val) {
    this.element.classList[val ? 'add' : 'remove']('has-changes');
  }

  get url() {
    return this.data.get('url');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/brief-drafts-controller.js